/**
 * Kétujjas húzós zoom prevent.
 * @param e - Event.
 */
export default function pinchPreventer (e: Event): void {
  const fingers = (e as TouchEvent).touches.length

  if (fingers > 1) {
    if (e.cancelable) {
      e.preventDefault()
    }

    e.stopPropagation()
  }
}
